import React from "react";
import SidebarSection from "@/components/sidebar/sidebar-components/sidebar-section";
import logo from "@/assets/sidebar/history.svg";

const HistorySidebarSection = () => {
  return <SidebarSection image={logo} title="History" href={"/history"} />;
};

export default HistorySidebarSection;
